module.exports = __webpack_public_path__ + "./assets/img_jiaoxi_color__b8ff81c724e2c151fb7d930dcf8037b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_jiaoxi_color.jpg
// module id = 606
// module chunks = 12